import { useEffect } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { useGetCurrentUserQuery } from 'gql';
import { getStoredTenantIdentifier, setStoredTenantIdentifier, clearStoredTenantIdentifier } from 'utils/tenantStorage';
import { getTenantIdentifier } from 'utils/tenantUtils';

export const useAppInitializer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const storedTenantIdentifier = getStoredTenantIdentifier();
  const returnUrl = searchParams.get('returnUrl');
  const clearback = searchParams.get('clearback');
  const tenantIdentifier = getTenantIdentifier();
  const { data: currentUser, isSuccess, isError, isLoading } = useGetCurrentUserQuery({}, { onError: () => null });

  useEffect(() => {

    if (isLoading) {
      return;
    }

    // Clearback is set by the server when the user is redirected after logging in
    if (tenantIdentifier && clearback === 'true') {
      setStoredTenantIdentifier(tenantIdentifier);
      searchParams.delete('clearback');

    }

    if (location.pathname === '/login') {
      if (currentUser?.me) {
        navigate(`/${tenantIdentifier}`, { replace: true });
      }
      return;
    }

    if (isError || !currentUser?.me) {
      if (storedTenantIdentifier) {
        clearStoredTenantIdentifier();
      }
      const currentPath = location.pathname + location.search;
      const loginReturnUrl = encodeURIComponent(currentPath);
      navigate(`/login?returnUrl=${loginReturnUrl}`, { replace: true });
      return;
    }


  }, [storedTenantIdentifier, isSuccess, isError, isLoading, currentUser, navigate, returnUrl, location.pathname, location.search, tenantIdentifier, clearback, searchParams]);

  return {
    isAuthenticated: isSuccess && !!currentUser?.me,
    isLoading: isLoading,
    user: currentUser?.me
  };
};